import type { OrderSummary } from '@repo/api-contracts';

/**
 * 주문 상태 배지의 결 — 내 견적 배지(QUOTE_STATUS_TONES)와 같은 체계로, 고객이 지금 무엇을 해야 하는지로 나눈다.
 * - action: 고객이 결제해야 한다(유일한 라임 강조).
 * - progress: 결제 뒤 운영자가 처리 중이다(취소 요청 처리 중 포함).
 * - complete: 배송까지 마쳤다.
 * - closed: 더 진행되지 않는다(취소·환불).
 */
export type OrderStatusTone = 'action' | 'progress' | 'complete' | 'closed';

export const orderStatusTone = (
  order: Pick<OrderSummary, 'status' | 'fulfillmentStatus'>,
): OrderStatusTone => {
  if (order.status === 'PENDING_PAYMENT') return 'action';
  if (order.status === 'CANCELED' || order.status === 'REFUNDED') return 'closed';
  return order.fulfillmentStatus === 'DELIVERED' ? 'complete' : 'progress';
};
